import { Component, Input, ViewChild } from '@angular/core';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { GoogleAnalyticsService } from 'src/app/common/services/google-analytics.service';
import { SharedService } from 'src/app/common/services/shared.service';
import { ReportService } from '../../services/report.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { MatMenuTrigger } from '@angular/material/menu';
import { ReportMapService } from '../../services/report-map.service';

@Component({
  selector: 'app-report-navigation-menu',
  templateUrl: './report-navigation-menu.component.html',
  styleUrls: ['./report-navigation-menu.component.scss']
})
export class ReportNavigationMenuComponent {
  @Input() selectedStudies:any;
  @Input() selectedRepored:any;
reportStudiesData: any = [];
currentLang:string ='1';
citySub$:Subscription = new Subscription();
languageSub$:Subscription = new Subscription();
@ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;
destroy$ = new Subject()

  constructor(
      private sharedService: SharedService,
      public reportService: ReportService,
      private activatedRoute: ActivatedRoute,
      private mapService: ReportMapService,
      private router: Router,
      private _googleAnalyticsService: GoogleAnalyticsService
    ){
      this.setLang();
    }

  openMenu(): void {
    this.menuTrigger?.openMenu();
  }

  closeMenu(): void {
    this.menuTrigger?.closeMenu();
  }

  selectReport(report: any, study: any, objtiveData: any): void {
    //check lock report
    if (this.reportService.userSubscription?.length) {
      let subsreport = this.reportService.userSubscription.find((type: any) => report.report_id == type.report_id)
      this.reportService.setLockReport((subsreport ? false : true));
    }else{
      console.log('you dont have any subscription');
      return;
    }
  if(report.report_id === this.selectedRepored?.report_id) return;
    this.reportService.isDateRangeFilterPresent.set(false)
    this.sharedService.clearSession('filter');
    this.mapService.mapFiltertoggle.next(false);
    this.mapService.mapLayertoggle.next(false);
    this.mapService.universalSearchtoggle.next(false);
    this.selectedRepored = report;
    this.selectedStudies = study;
    this.reportService.selectedObjective = {...objtiveData};
    this.reportService.selectedStudies = {...this.selectedStudies};
    this.reportService.selectedRepored = report ? {...report} : null;
    let queryParams = {
      oid: objtiveData.obj_id,
      gid: study.study_id,
      rid: report.report_id,
    };
    // ==
    let defaultValue = this.reportService.setDefaultFilter(report);
    queryParams = { ...queryParams, ...defaultValue };
    this.reportService.selectedReport$.next({flag: true});
    this.router.navigate(
      [`${this.sharedService.CityLang}/reports`],
      { queryParams: queryParams }
    );
    this.reportService.reportQueryToggle$.next(false);
    this.reportService.isProjectDetailOpen.set(false); 
  }

  ngOnInit(): void {
      if(this.sharedService.getStoreValue(GlobalContants.StoreKey.PlaceId)){
        this.getUserSubscription();
      } 
        this.getCurrentCity();
    }

    getObjectStudyReport(){
      this.reportService.getObjectStudyReport().subscribe(
        {next:(res: any) => {
          if(res.status === 200 && res.data){
            this.reportStudiesData = res.data;
            if(this.activatedRoute.snapshot.queryParams['rid']){
              this.reportService.reportQueryToggle$.next(false);
            } else {
              let result = this.reportStudiesData[0].studies
                            .map((study: any) => ({
                              ...study,
                              reports: study.report_default
                                ? study.reports.filter(
                                    (r: any) => r.report_id === study.report_default.report_id && study.active && (r.active || r.hidden === false)
                                  )
                                : []
                            }))
                            .find((study: any) => study.reports.length > 0);
              if(!result) {
                  result = this.reportStudiesData[0].studies.reduce((acc:any, study:any) => {
                        if (acc) return acc;
                        if (!study.active) return acc;
                        const reports = study.reports.filter(
                          (r:any) => r.active || r.hidden === false
                        );
                        if (reports.length > 0) {
                          return { ...study, reports };
                        }
                        return acc;
                    }, null);
              }

              if(result) {
                this.selectedRepored = null
                this.selectReport(result.reports[0], result, this.reportStudiesData[0]);
              }
            }
          } else {
            this.reportService.reportQueryToggle$.next(false);
            this.reportStudiesData = [];
          }
        },
        error: (error:any) => {
          this.reportService.reportQueryToggle$.next(false);
          this.reportStudiesData = [];
        }}
      )
    }
  
    getCurrentCity(){
      this.citySub$ = this.sharedService.selectedCity$.pipe(
        takeUntil(this.destroy$)
      ).subscribe(city => {
         this.reportStudiesData = [];
        if(this.sharedService.getStoreValue(GlobalContants.StoreKey.PlaceId)){
          this.getUserSubscription();
        }
      });
    }
  
    getUserSubscription(){
     this.reportService.getUserSubscription().subscribe(
        {next:(res: any) => {
          if (res && res.status == 200) {
            this.reportService.userSubscription = res.data[0]?.access_details;
            this.reportService.userSublength = res.data.length;
            this.reportService.reportPermission$.next(true);
            this.getObjectStudyReport();
          } else {
            this.reportService.userSublength = 0;
            this.reportService.userSubscription = [];
            this.getObjectStudyReport();
          }
        },
        error: (error:any) => {
          this.reportService.userSublength = 0;
          this.reportService.userSubscription = [];
          this.getObjectStudyReport();
        }}
      )
    }
  
  
    // toggleReport(){
    //   this.toggleSub$ = this.reportService.reportQueryToggle$.subscribe((toggle: boolean) => {
    //     this.collapseReports$ = toggle;
    //     if (!toggle && this.trigger?.menuOpen) {
    //       this.trigger.closeMenu(); // Close the menu if it's open
    //     }
    //   });
    // }
  
    setLang(): void{
      this.languageSub$ = this.sharedService.language$.subscribe(lang => {
        this.currentLang = lang === 'en' ? '1' : '2';
      })
    }
  
    collapseReportSide(toggle: boolean){
      this.reportService.reportQueryToggle$.next(toggle);
    }
  
    // onSearchChange(value: string){
    //   this.searchReportName = value;
    // }
  
    ngOnDestroy(): void {
      this.languageSub$?.unsubscribe();
      // this.toggleSub$?.unsubscribe();
      this.citySub$?.unsubscribe();
      // this.reportSub$?.unsubscribe();
      this.destroy$.next(true);
      this.destroy$.complete();
    }

}
